import { NgModule } from '@angular/core';

import { SubscribePageModule } from 'pages/subscribe/subscribe.module';
import { UnsubscribePageModule } from 'pages/unsubscribe/unsubscribe.module';
import { PurchaseSuccessPageModule } from 'pages/purchase-success/purchase-success.module';
import { RedeemCodePageModule } from 'pages/redeem-code/redeem-code.module';
import { ReferralHubPageModule } from 'pages/referral-hub/referral-hub.module';
import { ReferralInvitePageModule } from 'pages/referral-invite/referral-invite.module';
import { PromoPageModule } from 'pages/promo/promo.module';

const SUBSCRIPTION_PAGE_MODULES = [
  SubscribePageModule,
  UnsubscribePageModule,
  PurchaseSuccessPageModule,
  RedeemCodePageModule,
  ReferralHubPageModule,
  ReferralInvitePageModule,
  PromoPageModule,
];

/**
 * The paying-for-the-app screens, plus the referral programme that discounts them.
 *
 * One of the app's per-area page groups: it only groups page modules together,
 * declaring nothing of its own and adding no providers. Why these files exist and
 * what keeps them honest: `design-docs/angular-components.md`, "Creating New
 * Components", step 4.
 */
@NgModule({
  imports: SUBSCRIPTION_PAGE_MODULES,
  exports: SUBSCRIPTION_PAGE_MODULES,
})
export class SubscriptionPagesModule { }
